<div class="popup-form  wf-section">
  <button class="closedialog" (click)="closeDialog()">
    <i class="material-icons">close</i>
  </button>
  <div class="container">
    <div class="hero-title-center flex-inner">
      <div>
        <h2 class="hero-title _50px">
          <span class="add-scribble-below bold-700">Sign In</span>
          <span class="add-scribble-below"></span><br>
        </h2>
      </div>
    </div>
    <div class="margin-50px">
      <div class="w-form">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm)" autocomplete="new-password" id="email-form" name="email-form" data-name="Email Form" class="form schelude">
          <input formControlName="Email" id="email" (change)="fn_ResetOtherSites()"
                 type="email" class="text-field margin-bottom w-node-_5e5718c4-43f4-0d39-a8e5-2db3981574d1-e0529653 w-input"
                 maxlength="256" name="Email" data-name="Email"
                 placeholder="Enter your email"
                 required="">

          <div class="error-message" *ngIf="f.Email.touched && f.Email.invalid && f.Email.pristine">
            <div>Email is required.</div>
          </div>
          <div class="error-message" *ngIf="!f.Email.valid && (!f.Email.hasError('pattern') && f.Email.touched && f.Email.dirty)">
            <div>Email is required.</div>
          </div>
          <div class="error-message" *ngIf="!f.Email.valid && (f.Email.hasError('pattern') && f.Email.dirty)">
            <div>Invalid Email Address</div>
          </div>

          <input formControlName="Password" id="pwd" type="password"
                 class="text-field margin-bottom w-input"
                 maxlength="256" name="Password" data-name="Password"
                 placeholder="Password" required="">
          <div class="error-message" *ngIf="!f.Password.valid && f.Password.touched && (f.Password.pristine || f.Password.dirty)">
            <div>Password is required.</div>
          </div>

          <div class="margin-20px full-line">
            <input [disabled]="loginForm.invalid" type="submit" value="Sign In →" data-wait="Please wait..."
                   class="button subscribe orange full-button w-button">
          </div>

          <div class="margin-20px">
            <p class="cookies-font">
              <a (click)="openForgotPassDialog()" class="anchor-underline" data-w-id="5e5718c4-43f4-0d39-a8e5-2db3981574e1">Forgot Password</a>
            </p>
          </div>
          <div class="margin-20px">
            <p class="cookies-font">
              Don&#x27;t have an account yet? <a class="anchor-underline" (click)="openSignUp()">Sign Up</a>
            </p>
          </div>
        </form>



      </div>
    </div>
  </div>
  <img src="assets/img/scribbles-3.png" width="60"
       data-w-id="5e5718c4-43f4-0d39-a8e5-2db3981574e9"
       sizes="100vw"
       srcset="assets/img/scribbles-3-p-500.png 500w, assets/img/scribbles-3.png 608w" alt="" class="scribble-2">
  <img src="assets/img/scribbles-8.png" width="600" data-w-id="5e5718c4-43f4-0d39-a8e5-2db3981574ea"
       sizes="(max-width: 767px) 100px, (max-width: 991px) 200px, 400px" srcset="assets/img/scribbles-8-p-500.png 500w, assets/img/scribbles-8-p-800.png 800w, assets/img/scribbles-8-p-1080.png 1080w, assets/img/scribbles-8-p-1600.png 1600w, assets/img/scribbles-8.png 2287w" alt="" class="scribble-4">
</div>








